import React, { useEffect, useState } from "react";
import { KeyboardArrowUp } from "@material-ui/icons";

import { Styles } from "./style/backToTopStyle";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      const ratesSection = document.getElementById("rates");
      const visibilityPoint = ratesSection ? ratesSection.offsetTop : window.innerHeight;

      setIsVisible(window.scrollY >= visibilityPoint);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);

    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, []);

  const scrollToTop = () => {
    const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  };

  return (
    <Styles>
      <button
        type="button"
        className={`back-to-top${isVisible ? " visible" : ""}`}
        onClick={scrollToTop}
        aria-label="بازگشت به بالای صفحه"
        aria-hidden={!isVisible}
        tabIndex={isVisible ? 0 : -1}
      >
        <KeyboardArrowUp />
      </button>
    </Styles>
  );
};

export default BackToTop;
